import React from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import CopyButton from '../../common/controls/CopyButton';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import RequirePermission from '../../RequirePermission';
import { SUB_MODULES } from '../../../constants/subModulesConstants';
import InventoryItems from './InventoryItems';
import InventoryIcon from '@mui/icons-material/Inventory';
import CallSmsButtonCombo from '../../common/controls/CallSMSButtonCombo';

export default function InventorySupplierView({ handleEdit, open, onClose, supplier = null}) { 

    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(supplier);
    };

    if (!supplier) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>Supplier</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Supplier Name</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{supplier.name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Contact Person</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{supplier.contact_person}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>E-mail</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{supplier.email}</Typography>
                    <CopyButton text={supplier.email} />
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Contact Number</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{supplier.contact_number}</Typography>
                    <CopyButton text={supplier.contact_number} />
                </Box>
                <CallSmsButtonCombo phoneNumber={supplier.contact_number} bodyText={`Hello ${supplier.contact_person},`} />

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Address</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{supplier.address ? supplier.address : "(not provided)"}</Typography>
                    {supplier.address ? <CopyButton text={supplier.address} /> : null}
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(supplier.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(supplier.updatedAt)}</Typography>

            </DialogContent>
            <DialogActions>
                <RequirePermission subModuleName={SUB_MODULES.SUPPLIERS} minAccessLevel={2}>
                  <Button onClick={handleEditClick}>
                    <EditIcon />
                  </Button>
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.INVENTORY} minAccessLevel={1}>
                <InventoryItems 
                  mode="icon" 
                  supplier={supplier} 
                />
                </RequirePermission>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}